// styles & types & assets
import styles from "./SubTitle.module.scss";
type TProps = {
  children: React.ReactNode;
};
export default function SubTitle({ children }: TProps) {
  return (
    <section className={styles["wrapper-sub-title"]}>
      <span className={styles["sub-title"]}>{children}</span>
    </section>
  );
}
